'use client'

import { useTranslations } from 'next-intl'

import { Button, Icon } from '@graftcode/design-system'

import { PORTAL_ONBOARDING_LAYOUT, PORTAL_ONBOARDING_STEPS } from '@apps/portal-onboarding/portal-onboarding.const'
import { PORTAL_ONBOARDING_TEST_IDS } from '@apps/portal-onboarding/portal-onboarding-test-ids.const'

import { usePortalOnboardingStepView } from '../../hooks'
import { PortalOnboardingOverlay } from '../../PortalTutorialOverlay'

import styles from '../../PortalTutorial.module.scss'

export function PortalOnboardingStepView() {
  const t = useTranslations('portalOnboarding')
  const {
    currentStep,
    currentStepIndex,
    isLastStep,
    targetRect,
    targetElement,
    isPositioned,
    floatingStyles,
    pointerSide,
    arrowData,
    setArrowElement,
    setFloatingElement,
    handleDismiss,
    previousStep,
    handleFinish,
  } = usePortalOnboardingStepView()

  if (!currentStep) {
    return null
  }

  return (
    <>
      <PortalOnboardingOverlay targetRect={targetRect} showHighlight />
      <div
        ref={setFloatingElement}
        className={styles.popover}
        style={{
          ...floatingStyles,
          visibility: targetElement && isPositioned ? 'visible' : 'hidden',
        }}
        role="dialog"
        aria-modal="true"
        data-testid={PORTAL_ONBOARDING_TEST_IDS.step}
      >
        <div
          ref={setArrowElement}
          className={styles.pointer}
          style={{
            left: arrowData?.x != null ? `${arrowData.x}px` : undefined,
            top: arrowData?.y != null ? `${arrowData.y}px` : undefined,
            [PORTAL_ONBOARDING_LAYOUT.pointerStaticSide[pointerSide]]: `-${PORTAL_ONBOARDING_LAYOUT.pointerWidth}px`,
            transform: `rotate(${PORTAL_ONBOARDING_LAYOUT.pointerRotation[pointerSide]}deg)`,
          }}
          aria-hidden
        >
          <div className={styles.pointerShape} />
        </div>
        <div className={styles.popoverCard}>
          <div className={styles.popoverHeader}>
            <h2 className={styles.popoverTitle}>{t(`steps.${currentStep}.title`)}</h2>
            <Button
              className={styles.closeButton}
              variant="ghost"
              size="m"
              iconOnly
              icon={Icon.DismissRegular}
              aria-label={t('actions.close')}
              onClick={handleDismiss}
            />
          </div>
          <p className={styles.popoverBody}>
            {t.rich(`steps.${currentStep}.description`, {
              strong: (chunks) => <strong>{chunks}</strong>,
            })}
          </p>
          <div className={styles.footer}>
            <Button
              variant="outlined"
              size="m"
              text={t('actions.back')}
              disabled={currentStepIndex === 0}
              onClick={previousStep}
            />
            <span className={styles.progress}>
              {t('progress', {
                current: currentStepIndex + 1,
                total: PORTAL_ONBOARDING_STEPS.length,
              })}
            </span>
            <Button
              variant="primary"
              size="m"
              text={isLastStep ? t('actions.finish') : t('actions.next')}
              onClick={handleFinish}
            />
          </div>
        </div>
      </div>
    </>
  )
}
